import winController from './winController';
import { gsap } from 'gsap';
import SoundManager from 'Engine/soundManager/SoundManager';
import { eSounds } from '../../../enums/eSounds';

export default class BigWinController extends winController {
  constructor(props) {
    super(props);
    this._moveCounterDuration = 2;
    // this._scaleCounterDuration = 3;
    this._moveCounterValue = 40;
    // this._scaleCounterValue = 1.3;

    this._tweens = [];
  }

  onStart() {
    this.panelSmall.visible = false;
    this.panelBig.visible = false;
    if (this.panelSmall.particles) {
      this.panelSmall.particles.stop();
      this.panelSmall.particles = null;
    }
    if (this.panelBig.particles) {
      this.panelBig.particles.stop();
      this.panelBig.particles = null;
    }

    this._tweens.push(
      gsap.to(this.winContainer, { y: `+=${this._moveCounterValue}`, duration: this._moveCounterDuration, ease: 'power4.out' }),
      // gsap.to(this.counter.scale, {
      //   x: this._scaleCounterValue,
      //   y: this._scaleCounterValue,
      //   duration: this._scaleCounterDuration
      // }));
    );

    this.ControllerPopup.showOverlay(1000);
    this.coinParticles.visible = true;
    this.coinParticles.start();
    this._dirty = true;
  }

  onSkip() {
    this.onStart();
  }

  cleanup() {
    super.cleanup();
    if (!this._dirty) return;
    SoundManager.play(eSounds.EST_WIN_END.soundName, eSounds.EST_WIN_END.volume, false, eSounds.EST_WIN_END.group);

    this._tweens.forEach(tween => tween.kill());
    this._tweens = [];
    this.winContainer.y = window.OPWrapperService.ScaleManager.currentData.isPortrait ? 140 : 0;
    if (this.coinParticles) {
      this.coinParticles.stop();
      this.coinParticles.visible = false;
    }
    // this.counter.scale.set(1);
    this._dirty = false;
  }
}
